import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addContactStatus, getContactStatus, updateContactStatus, deleteContactStatus } from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class ContactStatus extends Component {
    constructor(props) {
        super(props)
        this.state = {
            status: ''
        }
        this.handleContactStatusSubmit = this.handleContactStatusSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (status) => {
        this.setState({ status: status });
        this.setState({ deleteModal: true });
    };

    handleDeleteContactStatus = () => {
        const { onDeleteContactStatus } = this.props;
        const { status } = this.state;

        if (status.id !== undefined) {
            onDeleteContactStatus(status);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleContactStatusSubmit(value) {
        this.props.addContactStatus(value, this.props.history);
    }

    componentDidMount() {
        const { onGetContactStatus } = this.props;
        onGetContactStatus(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { statuses } = this.props;
        if (!isEmpty(statuses) && size(prevProps.statuses) !== size(statuses)) {
            this.setState({ statuses: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ status: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const status = arg;
        this.setState({
            status: {
                id: status.id,
                contactStatusId: status.contactStatusId,
                contactStatusTitle: status.contactStatusTitle,
                agentId: status.agentId
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { statuses, onUpdateAppContactStatus } = this.props;
        const { isEdit, deleteModal } = this.state;
        const status = this.state.status;
        
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteContactStatus}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Contact Status")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        contactStatusTitle: (this.state && this.state.contactStatusTitle) || "",

                                    }}
                                    validationSchema={Yup.object().shape({
                                        contactStatusTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleContactStatusSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <CardTitle>Contact Status</CardTitle>
                                                    <Row>


                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="contactStatusTitle">
                                                                    {this.props.t("Title")}
                                                                </Label>
                                                                <SafeField
                                                                    name="contactStatusTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.contactStatusTitle && touched.contactStatusTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="contactStatusTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="contactStatusTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(statuses, (status, statuskey) => (
                                                                    <tr key={"_list_" + statuskey}>
                                                                        <th>{statuskey + 1}</th>
                                                                        <td>{status.contactStatusTitle}</td>
                                                                        <td>
                                                                            <ActionEdit onClick={() => this.toggleRightCanvas(status)} />
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
                                                                            <ActionDelete onClick={() => this.onClickDelete(status)} />
                                                                            

                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: status.id,
                                        contactStatusId: status.contactStatusId,
                                        contactStatusTitle: status.contactStatusTitle,
                                        agentId: status.agentId

                                    }}
                                    validationSchema={Yup.object().shape({
                                        contactStatusTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {

                                                id: values.id,
                                                contactStatusId: values.contactStatusId,
                                                contactStatusTitle: values.contactStatusTitle,
                                                agentId: values.agentId
                                            };
                                            onUpdateAppContactStatus(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                                <Col sm="12">
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="contactStatusTitle">
                                                            {this.props.t("Title *")}
                                                        </Label>
                                                        <SafeField
                                                            name="contactStatusTitle"
                                                            onChange={handleChange}

                                                            type="text"

                                                            className={
                                                                "form-control" +
                                                                (errors.contactStatusTitle && touched.contactStatusTitle
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }

                                                            id="contactStatusTitle"
                                                        />
                                                        <ErrorMessage
                                                            name="contactStatusTitle"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </FormGroup>

                                                </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
ContactStatus.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addContactStatus: PropTypes.func,
    onGetContactStatus: PropTypes.func,
    statuses: PropTypes.array,
    onDeleteContactStatus: PropTypes.func,
    onUpdateAppContactStatus: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        statuses: AppoinmentObject.statuses,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addContactStatus: (data) => dispatch(addContactStatus(data)),
    onGetContactStatus: (agentId) => dispatch(getContactStatus(agentId)),
    onDeleteContactStatus: (id) => dispatch(deleteContactStatus(id)),
    onUpdateAppContactStatus: (data) => dispatch(updateContactStatus(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContactStatus))
